import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import Button from "../../components/common/Button";
import { getWeekendInfoByName } from "../../backend/weekends/weekendInfo";
import { sanitizeHTML } from "../../utils/htmlSanitizer";

const LandingTopCard = ({ weekendId }: {weekendId:number}) => {
  const showCard = useMediaQuery({ query: `(min-width: 1024px)` });
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
  return (
    <div style={{ ...styles.cardWrapper, flexDirection: isMobile ? "column" : "row" }}>
      <div
        style={{
          ...styles.cardContainer,
          margin: isMobile ? "3.5rem auto" : "5rem auto",
          marginTop: isMobile ? "3.5rem" : "5rem",
          marginLeft: isMobile ? "auto" : "var(--main-container-margin)",
          justifyContent: "center",
        }}
      >
        <p
          style={{ ...styles.mainHeading, fontSize: isMobile ? "10vw" : "clamp(3rem,4vw,5rem)" }}
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(getWeekendInfoByName(weekendId,"topCardHeader")) }}
        ></p>
        <p
          style={{
            ...styles.descriptionText,
            fontSize: isMobile ? "7vw" : "clamp(2rem,4vw,2.7rem)",
          }}
        >
          {getWeekendInfoByName(weekendId,"topCardDescription")}
          
        </p>
      </div>
      {isMobile && <img src={getWeekendInfoByName(weekendId,"topCardPhotoLinkMobile")} style={{ width: "100%" }} onError={(e) => e.currentTarget.src = "/assets/landing/photo1-mobile.jpg"} />}
      {showCard && (
        <div style={{ flex: 1 }}>
          <img
            src={getWeekendInfoByName(weekendId,"topCardPhotoLink")}
            style={{ width: "33vw", height: "100%", objectFit: "cover" }}
            onError={(e) => e.currentTarget.src = "/assets/landing/photo1.jpg"}
          />
        </div>
      )}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  cardWrapper: {
    display: "flex",
    width: "100%",
    backgroundColor: "var(--white)",
    overflow: "visible",
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "var(--main-container-width)",
  },
  mainHeading: {
    color: "var(--dark-grey)",
    fontWeight: "bold",
    marginBottom: "3rem",
  },
  descriptionText: {
    color: "var(--dark-grey)",
  },
};

export default LandingTopCard;
